import {
  hasStoryAccess as hasStoryAccessApi,
  incrementPremiumStoriesRead as incrementPremiumStoriesReadCountApi
} from "./api";
import { isGaa } from "./components/utils/utils";
import { isPremium } from "./data/story";

function getStoriesReadFromLocalStorage() {
  if (global.localStorage) {
    return JSON.parse(global.localStorage.getItem("premiumStoriesRead") || '{"storyIds": []}');
  }

  return {
    storyIds: []
  };
}

export function hasStoryAccess(story) {
  return new Promise((resolve, reject) => {
    if (!isPremium(story)) {
      resolve({ granted: true, grantReason: "FREE" });
    }

    if (isGaa()) {
      resolve({ granted: true, grantReason: "FREE" });
    }

    global.userPromise.catch(() => null).then(user => {
      if (!user) {
        return resolve({
          granted: false,
          grantReason: "METERING",
          remainingStoriesCount: 0
        });
      }

      hasStoryAccessApi(story.id)
        .then(resolve)
        .catch(reject);
    });
  });
}

export function incrementPremiumStoriesRead(storyId) {
  if (global.localStorage) {
    if (!storyId) {
      const storiesAlreadyRead = getStoriesReadFromLocalStorage();
      return incrementPremiumStoriesReadCountApi(storiesAlreadyRead.storyIds);
    }
    const currentDate = new Date();
    let alreadyViewedStories = new Set([]);
    const storiesAlreadyRead = getStoriesReadFromLocalStorage();
    if (storiesAlreadyRead.expiresAt > currentDate.valueOf()) {
      alreadyViewedStories = new Set(storiesAlreadyRead.storyIds);
    }
    alreadyViewedStories.add(storyId);
    return incrementPremiumStoriesReadCountApi(storyId);
  }
}
